import Vue from 'vue'
import Loading from '@/components/Utils/Loading.vue'

Vue.component('Loading', Loading)
